//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  props: {
    /**
     * Area page: diet | sex-drive | stress | energy | sleep
     */
    area: {
      type: String,
      required: true
    },
    /**
     * Starter test
     */
    starterTest: {
      type: Object,
      required: true
    },
    carouselImagesParam: {
      type: Array,
      required: false
    }
  },
  computed: {
    ...mapGetters({
      getPlanPrice: 'product/getPlanPrice'
    }),
    biomarkers () {
      return this.starterTest.test.biomarkersTested
    },
    testType () {
      return this.starterTest.test.collectionType
    },
    image () {
      return this.getStaticsObject(`/quiz-results/starter_test_${this.testType}.webp`)
    },
    carouselImages () {
      if (this.carouselImagesParam) {
        return this.carouselImagesParam
      } else {
        return [
          `https://statics.get-base.com/quiz-results/starter_test_box_${this.area}.jpg`,
          `https://statics.get-base.com/quiz-results/starter_test_inside_box_${this.testType}.webp`,
          `https://statics.get-base.com/quiz-results/starter_test_collection_${this.testType}.webp`
        ]
      }
    }
  },
  methods: {
    emitOpenFastTrackModal () {
      this.$emit('trackAddToCart')
    }
  }
}
